module.exports = __webpack_public_path__ + "media/warehouse_by_volume/Img-24m2-87effbea.png";